import React, { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';
import { LockIcon } from './common/InlineIcons';
import { gateDecision } from './passwordGateRules';

import { SITE_LOCKED, SITE_PASSWORD } from '../constants/site';
const STORAGE_KEY = 'site-password';

export default function PasswordGate({ children }) {
  const { VB } = useTheme();
  // This gate wraps the entire site, so a missing provider here would blank the
  // whole app. Tolerate a missing auth context instead of throwing — the worst
  // case is the visitor sees the password form rather than an early-access bypass.
  const { user } = useAuth() || {};
  const location = useLocation();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [unlocked, setUnlocked] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === SITE_PASSWORD;
    } catch {
      return false;
    }
  });

  // Early access lasts as long as the site is locked. It used to also require
  // !isPostLaunch, which revoked it on a fixed date regardless of whether the
  // site had opened — so a launch running even an hour late shut out every
  // organizer. Once SITE_LOCKED is false gateDecision returns 'open', so there
  // is nothing left for a date to decide.
  if (gateDecision(user?.role, location.pathname, SITE_LOCKED, SITE_PASSWORD) !== 'gate') {
    return children;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === SITE_PASSWORD) {
      try {
        localStorage.setItem(STORAGE_KEY, SITE_PASSWORD);
      } catch {}
      setUnlocked(true);
      setError('');
      return;
    }
    setError('Incorrect password. Please try again.');
  };

  if (unlocked) return children;

  return (
    <div style={{ minHeight: '100vh', background: VB.void, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 440, background: VB.darkCard, border: `1px solid ${VB.borderLight}`, borderRadius: 16, padding: 32, textAlign: 'center', boxShadow: VB.cardShadowHover }}>
        <div style={{ color: VB.red, display: 'flex', justifyContent: 'center', marginBottom: 10 }}><LockIcon size={38} strokeWidth={1.8} /></div>
        <h1 style={{ margin: 0, color: VB.snowPrimary, fontSize: 30, fontWeight: 800 }}>Vibana Preview</h1>
        <p style={{ margin: '10px 0 24px', color: VB.snowMuted, fontSize: 14 }}>This site is currently in private preview</p>

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            autoFocus
            style={{ width: '100%', background: VB.darkCardAlt, border: `1px solid ${VB.borderLight}`, color: VB.snowPrimary, borderRadius: 10, padding: '12px 14px', fontSize: 15, outline: 'none', marginBottom: 12 }}
          />
          <button
            type="submit"
            style={{ width: '100%', background: VB.red, color: VB.white, border: 'none', borderRadius: 10, padding: '12px 16px', fontSize: 15, fontWeight: 700, cursor: 'pointer' }}
          >
            Enter Site
          </button>
        </form>

        {error ? <p style={{ marginTop: 12, marginBottom: 0, color: VB.red, fontSize: 13 }}>{error}</p> : null}
      </div>
    </div>
  );
}
